<app-modal>
  <div class="modal-header py-sm-4" header>
    <div class="container d-flex justify-content-between align-items-center">
      <div class="modal-title">
        <h1 class="m-0">Identify Feature</h1>
      </div>
      <button type="button" class="btn btn-secondary" (click)="close()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>
  <div class="modal-body pt-3 pt-lg-5" body>
    <div class="container">
      <p>
        Note that you must click on a valid map feature. It may help to zoom in. Please close and
        try again.
      </p>
    </div>
  </div>
  <div class="py-3 modal-footer" footer>
    <div class="container">
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-secondary" (click)="close()">
          Close <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  </div>
</app-modal>
